export default __webpack_public_path__ + "static/media/kiranafast.f19f8802.png";